import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import VibraUserIcon from '../../assets/vibra-user-icon.svg'
import download from 'downloadjs';
import { base64 } from '../../constants/validate';
import { useSnackbar } from "../../hooks/useSnackbar"
import axios from 'axios';


//components
import Avatar from '../Avatar';
import Spinner from '../Spinner';
import ConfirmationModal from '../ConfirmationModal';
import { Button, Tooltip } from '../DesignSystem';

//services
import { getChatMessages, addChatMessage, addFileMessage, getFileData, sendEmail } from '../../services/chatService';

//styles
import './index.scss';

function ChatMessage({ data, date, userId, userRoleId, isLastUserMessage }) {

    const [isDownloading, setIsDownloading] = useState(false) 

    
    function getMessageClassName() {
        let className = 'chat-message '
        if(userId === data.userData.id || (userRoleId === 1 && data.userData.roleId === 1)) className += 'chat-message--user-message '
        if(data.type === 'file') className += 'chat-message--file-message '

        return className
    }

    function renderFileSize(bytes) {
        if (typeof bytes === 'string') {
            bytes = parseInt(bytes, 10);
        }
    
        if (bytes < 0) throw new Error("bytes cannot be negative");
    
        let humano;
        let sufixo;
    
        switch (true) {
            case (bytes >= 1152921504606846976): // Exabyte (1024^6)
                humano = bytes / Math.pow(1024, 6);
                sufixo = "EB";
                break;
            case (bytes >= 1125899906842624): // Petabyte (1024^5)
                humano = bytes / Math.pow(1024, 5);
                sufixo = "PB";
                break;
            case (bytes >= 1099511627776): // Terabyte (1024^4)
                humano = bytes / Math.pow(1024, 4);
                sufixo = "TB";
                break;
            case (bytes >= 1073741824): // Gigabyte (1024^3)
                humano = bytes / Math.pow(1024, 3);
                sufixo = "GB";
                break;
            case (bytes >= 1048576): // Megabyte (1024^2)
                humano = bytes / Math.pow(1024, 2);
                sufixo = "MB";
                break;
            case (bytes >= 1024): // Kilobyte (1024^1)
                humano = bytes / 1024;
                sufixo = "KB";
                break;
            default: // Byte
                return bytes + " B";
        }
    
        return humano.toFixed(2) + " " + sufixo;
    }

    async function downloadFile(fileId) {
        try {
            setIsDownloading(true)

            const {data, metadata} = await getFileData(fileId)
            const {type} = metadata

            console.log(metadata)
            download(base64(data,type), metadata.real_name)
            
        } catch (error) {
            console.error(error)
        }
        finally{
            setIsDownloading(false)
        }
    }

    return (
        <>
            <div className={getMessageClassName()}>
                {data.type ==='file' ?  
                    <div className='chat-message__file-data'>
                        {isDownloading ? 
                            <Spinner size={20} style={{width: '30px', height: '35px'}}/> :
                            <Button onClick={() =>downloadFile(data.fileData.id)} icon={'File'} sizeIcon={20} style={{padding: '2px 4px'}}>
                                <p>{data.fileData.realName} <span>({renderFileSize(data.fileData.size)})</span></p>
                            </Button>
                        }
                    </div> :
                
                    <p>{data.message}</p>
                }

            </div>
            {isLastUserMessage && (
                <div className={`chat-message__data ${userId === data.userData.id || (userRoleId === 1 && data.userData.roleId === 1) ? 'chat-message__data--user-message' : ''}`}>
                    
                    {data.userData.roleId === 1 ? <img style={{width:'24px', height: '24px'}} src={VibraUserIcon}></img> : <Avatar name={data.userData.name} size='small' /> }
                    <div className='chat-message__data__info'>
                        <div className='chat-message__data__info__name'>
                            <h2>{data.userData.name}</h2> 
                            {data.userData.relationshipName === 'ADVOGADO' && 
                            <span className='chat-message__data__info__name__flag' 
                            style={{backgroundColor: data.userData.roleId === 1 && '#0E7716' }}>
                                {data.userData.roleId === 1 ? 'Vibra' : 'ADVOGADO'}
                            </span>
                            }
                        </div>
                        {date} às {data.time}
                    </div>
                </div>
            )}
        </>
    );
}

function Chat({ caseId, currentStatusCase ,handleChangeStatus = () => {} }) {
    const { app:{user:{id:userId, roles_id:userRoleId}}, crm:{currentCase}, charge:{debtInfo} } = useSelector(state => state)

    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentMessages, setCurrentMessages] = useState([]);
    const [groupedMessages, setGroupedMessages] = useState(getGroupedMessages([]));
    const snackbar = useSnackbar()
    // const [selectedFiles, setSelectedFiles] = useState([]);
    const timelineRef = useRef(null);
    const inputFileRef = useRef(null)
    const [reopenDisplay, setReopenDisplay] = useState('');

    const caseMode = getCaseMode()

    console.log(currentCase.status_cases_id)

    function getCaseMode(){
        if(!currentCase?.cases_types_id) return null;
        if(currentCase.cases_types_id === 1) return 'FINANCEIRO';
        if(currentCase.cases_types_id === 2) return 'JUDICIAL';
    }

    const { data,isLoading: isLoadingChatMessages } = useQuery({
        queryKey: ['chat-messages', caseId],
        queryFn: async() => fetchChatMessages(),
        staleTime: 1000 * 60,
        // enabled: !_.isEmpty(accessToken) && !_.isEmpty(route),
        refetchOnWindowFocus: true,
        keepPreviousData: true,
        retry: false,
        refetchInterval: 10000,
      })
    
    async function fetchChatMessages(){
    try {
        if(!caseId) throw {message: 'case id não foi definido'}
        const data = await getChatMessages(caseId)
        return data
    } catch (error) {
        console.error(error)
    }
    }

    function handleClickChooseFile(e){
        e.preventDefault()
        inputFileRef.current.click()
    }

    function handleFilesChange(e){
        const selectedFiles = Array.from(e.target.files)
        sendFilesMessages(selectedFiles)
    }

    async function sendFilesMessages(files) {
        try {
            setLoading('user-message');

          for (const fileData of files) {
            const formData = new FormData();
      
            formData.append('file', fileData);
            formData.append('filename', fileData.name);
            formData.append('size', fileData.size.toString());
            formData.append('userId', userId);
      
            const response = await addFileMessage(caseId, userId, formData)
            if(!response || response === '') throw 'Erro ao enviar arquivo'
            setCurrentMessages([...currentMessages, response])
      
          }
        } catch (error) {
          console.error(error);
        }
        finally {
            setLoading('');
        }
      }
      
    function getGroupedMessages() {
        const groupedMessages = currentMessages.reduce((acc, message) => {
            const [created, time] = moment(message.created).format('DD/MM/YYYY HH:mm').split(' ');

            if (!acc[created]) {
                acc[created] = [];
            }

            acc[created].push({ ...message, time, });
            return acc;
        }, {});

        const sortedDates = Object.keys(groupedMessages).sort((a, b) => {if(moment(a.created).isBefore(moment(b.created))) {return -1} else {return 1}});

        const result = sortedDates.map(created => ({
            created,
            messages: groupedMessages[created]
        }));

        return result;
        // return [{created: '21/08/2024', messages: [{type: 'file', file_name: 'example.pdf', size: 2000, id: '156456456',  }]}]

    }

    async function sendEmailNotification(){
        try {
            const lawsuit_number = currentCase.process_number
            const link = window.location.href;
            if(!lawsuit_number || !link) throw {message:'parametros invalidos', params:{lawsuit_number, link}}
            await sendEmail({lawsuit_number, link});
        } catch (error) {
            console.error(error);
        }

        
    }

    async function sendMessage(textMessage) {
        try {
            if(loading === 'user-message' || textMessage === '') return
            setLoading('user-message');
            const hasDebtorsMessage = currentMessages.some(message => message.userData.roleId === 3)
            if(!hasDebtorsMessage) await sendEmailNotification();
            if(!caseId) throw '+=+=+=+=+=+=+= case id is undefined +=+=+=+=+=+=+='
            let messageData = {
                message: textMessage,
                type: 'text',
                userId,
            };
            setNewMessage('');
            const successMessageData = await addChatMessage({caseId, messageData})
            console.log({successMessageData});
            setCurrentMessages([...currentMessages, successMessageData]);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading('');
        }
    }

    function returnStatusDescription(statusId) {
        switch (statusId) {
          case 1:
            return "Aguardando contato";
          case 2:
            return "Negociando";
          case 3:
            return "Aguardando assinaturas";
          case 4:
            return "Concluido";
          case 5:
            return "Arquivado";
          case 6:
            return "Aguardando pagamento";
          case 7:
            return "Aguardando assinatura e pagamento";
          case 9:
            return "Encerrado";
          case 10: 
            return "Negociando"
          case 11: 
            return "Aguardando contato"
          case 12: 
            return "Aguardando assinaturas"
          case 13: 
            return "Concluido"
          case 14: 
            return "Aguardando pagamento"
          case 15: 
            return "Aguardando assinatura e pagamento"
          case 16: 
            return "Encerrado"
          case 17: 
            return "Arquivado"
          case 18: 
            return "Arquivado"
          default:
            return "Negociando por chat";
        }
      }

    async function changeCaseStatus(statusId, reason = null, amount = null) {
        try {
          handleChangeStatus(returnStatusDescription(statusId))
          

          let body;
          let url;

          
          if(statusId !== 17 && statusId !== 18 && caseMode === 'JUDICIAL') {
            setReopenDisplay('none')
            setLoading('changing-status');
            snackbar("Caso alterado.")
            await sendMessage('Sim')
            await axios.post('/case/change-status',{id:currentCase?.id, statusId})
          }else {
            setLoading('closing-case');
            if(caseMode === 'JUDICIAL'){ 
              body = {id:currentCase?.id, statusId}
              url = '/case/change-status'
              await sendMessage('Não')
            //   await sendMessage('Não')
            }else {
              body = { id: currentCase?.id}
              url = '/case/executed'
            }
    
            await axios.post(url,body);
            // snackbar("Caso encerrado.")
          }
                
        } catch (error) {
          console.error(error);
          snackbar("Houve um erro ao atualizar o caso")
    
        } finally {
            setLoading('');
        }
      }


    async function onKeyPress(e) {
        if(e.key === 'Enter') sendMessage(newMessage)
    }

    useEffect(() => {
        if (currentMessages) setGroupedMessages(getGroupedMessages(currentMessages));
    }, [currentMessages]);

    useEffect(() => {
        if (timelineRef.current) {
            timelineRef.current.scrollTo({
                top: timelineRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    }, [groupedMessages, loading]);

    useEffect(() => {if(data)setCurrentMessages(data)},[data])

    return (
        <div className='chat'>
            <div className='chat__timeline' ref={timelineRef}>
                {(groupedMessages.length === 0 && loading === '') ? 
                <p className='chat__timeline__intro'>Nenhuma mensagem enviada</p> :
                groupedMessages.map((group, index) => (
                    <div key={index} className='chat__group'>
                        {group.messages.map((message, index) => (
                            <ChatMessage 
                            key={index} 
                            data={message} 
                            date={group.created} 
                            userId={userId} 
                            userRoleId={userRoleId} 
                            isLastUserMessage={
                                group.messages.length === index + 1 || 
                                message.userData.roleId !== group.messages[index + 1]?.userData.roleId ||
                               ( message.userData.roleId === 3 && message.users_id !== group.messages[index + 1]?.users_id)
                            } />
                        ))}
                    </div>
                ))
                }
                {loading === 'user-message' && <Spinner size={16} style={{marginLeft: 'auto', marginRight: '0px', width: 'fit-content', height: 'fit-content'}}/>}

                {(currentStatusCase === 'Aguardando contato') && (
                    <div className='chat-buttons'>
                        <Button loading={loading === 'closing-case'} disabled={loading !== ''} onClick={()=> changeCaseStatus(18)}>Não</Button>
                        <Button contained loading={loading === 'changing-status'} disabled={loading !== ''} onClick={()=> changeCaseStatus(99)}>Sim</Button>
                    </div>
                )}
               {(currentCase.status_cases_id === 18) && (
                    <div className='chat-buttons'>
                        <Button style={{display:reopenDisplay}} contained loading={loading === 'changing-status'} disabled={loading !== ''} onClick={()=> changeCaseStatus(99)}>Desejo abrir negociação</Button>
                    </div>
                )}
                
            </div>
            
            {(currentCase.status_cases_id !== 18 && currentStatusCase !== 'Aguardando contato' && currentStatusCase !== 'Concluido' && currentStatusCase !== 'Encerrado' && currentStatusCase !== 'Arquivado') &&
                <div className='chat__footer-bar'>
                <div className='chat__footer-bar__input-container'>
                    <input placeholder='Digite aqui a sua mensagem' value={newMessage} onChange={(e) => setNewMessage(e.target.value)} onKeyPress={onKeyPress}/>
                    <input type='file'ref={inputFileRef} onChange={handleFilesChange} style={{ display: 'none' }} multiple/>
                    <Tooltip title='Adicionar anexos' delay={0.5}>
                        <Button 
                        icon='Paperclip' 
                        sizeIcon={16} 
                        disabled={loading === 'user-message'} 
                        style={{ width: '32px', height: '32px', color: '#5A5A5A', padding: '0px'}} 
                        onClick={handleClickChooseFile} />
                    </Tooltip>
                </div>
                <Button 
                icon='Send' 
                disabled={loading === 'user-message'} 
                style={{ width: '48px', height: '48px', color: '#ffffff', backgroundColor: '#26A69A', borderRadius: '8px' }} 
                onClick={() => sendMessage(newMessage)} />
            </div>}
            <ConfirmationModal
                show={modalIsOpen}
                onClose={() => setModalIsOpen(false)}
                onConfirmation={changeCaseStatus}
                defaultStatus={'16'}
                message="Deseja realmente encerrar o caso?"
                title="Encerrar caso"
            />
        </div>
    );
}

export default Chat;
